"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActionTrackingPayload = exports.parseCustomTrackingValue = exports.parseActionTrackingValue = void 0;
const types_1 = require("./types");
/**
 * Extra parser for the "value" param of action tracker metric
 *  Back-end saves action tracker setup in stringified JSON format
 *  for historical reasons (saved in visual editor, and needed for the Tag compilation)
 * @param actionTrackingValue - the value param of the action tracker metric
 * @returns parsed Action Tracker Value or null
 */
const parseActionTrackingValue = (actionTrackingValue, actionTrackingName) => {
    if (typeof actionTrackingValue === 'string') {
        try {
            const parsedValue = JSON.parse(actionTrackingValue);
            if ('name' in parsedValue) {
                return parsedValue;
            }
            return null;
        }
        catch (e) {
            console.log(new Error(`failed to parse string: "${actionTrackingValue}", for tracker: ${actionTrackingName}`));
            return null;
        }
    }
    return actionTrackingValue;
};
exports.parseActionTrackingValue = parseActionTrackingValue;
const parseCustomTrackingValue = (customTrackingValue, customTrackingName) => {
    if (typeof customTrackingValue === 'string') {
        try {
            const parsedValue = JSON.parse(customTrackingValue);
            if ('conditions' in parsedValue && 'matches' in parsedValue) {
                return parsedValue;
            }
            return customTrackingValue;
        }
        catch (e) {
            console.log(new Error(`failed to parse string: "${customTrackingValue}", for tracker: ${customTrackingName}`));
            return customTrackingValue;
        }
    }
    return customTrackingValue;
};
exports.parseCustomTrackingValue = parseCustomTrackingValue;
const isActionTrackingPayload = (payload) => {
    return 'type' in payload && payload.type === types_1.MetricType.ActionTracking;
};
exports.isActionTrackingPayload = isActionTrackingPayload;
//# sourceMappingURL=helpers.js.map